import { render } from "./SignageDetails.vue?vue&type=template&id=71e2873d&scoped=true&ts=true"
import script from "./SignageDetails.vue?vue&type=script&lang=ts"
export * from "./SignageDetails.vue?vue&type=script&lang=ts"

import "./SignageDetails.vue?vue&type=style&index=0&id=71e2873d&lang=css"
import "./SignageDetails.vue?vue&type=style&index=1&id=71e2873d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e2873d"]])

export default __exports__